import React, { memo } from 'react';
import useRedirect from '../../customHooks/useRedirect';
import LazyImage from '../../CustomLibraries/LazyImage';
import { FiShare2, MdOutlineArrowRightAlt } from '../../icons';
import './css/_ebookCardV2.scss';

function EbookCardV2({ image, title, id, gtmTagVariable = '' }) {
  const { redirectTo } = useRedirect();
  const click = () => redirectTo('EbookDetails', id, title);
  return (
    <div
      className="w-100 ebookCardV2Box bg-white shadow rounded-3 d-flex position-relative overflow-hidden p-3 p-md-4"
      onClick={click}
    >
      <div className="d-flex z-1">
        <div className="ebookPic position-relative pt-4 me-3">
          <div className="ebookPicCover position-relative p-2">
            <div className="position-relative rounded bg-light overflow-hidden ebookPicArea border border-white z-2">
              <img
                src={image}
                alt="cover image"
                className={`w-100 h-auto ${gtmTagVariable}_ebookCardV2`}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-column text-start justify-content-center flex-1">
          <h2
            className={`fs-16 text-black fw-medium cursorPointer position-relative ebookTitle pb-3 mb-4 ${gtmTagVariable}_ebookCardV2`}
          >
            {title}
          </h2>
          <div className="cardFtr d-flex flex-wrap">
            <a
              href="javascript:void(0)"
              className={`fs-4 fw-medium btn btn-primary rounded-3 me-2 p-3 d-flex ${gtmTagVariable}_ebookCardV2`}
            >
              Read Now
              <MdOutlineArrowRightAlt
                customClass={`fs-2 ms-1 ${gtmTagVariable}_ebookCardV2_read_now_icon`}
                gtmTagVariable={`${gtmTagVariable}_ebookCardV2`}
              />
            </a>
            <a
              href="javascript:void(0)"
              className={`fs-4 fw-medium btn btn-secondary rounded-3 p-3 ${gtmTagVariable}_ebookCardV2`}
            >
              <FiShare2
                customClass={`fs-2 text-white me-1 ${gtmTagVariable}_ebookCardV2_share_icon`}
                gtmTagVariable={`${gtmTagVariable}_ebookCardV2`}
              />
              Share
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default memo(EbookCardV2);
